import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { getHeadlinesCardSummaryDetails, getLongHeadlinesCardSummaryDetails, getDescriptionsCardSummaryDetails } from '@bingads-webui-campaign-react/validated-text-collection';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const HeadlinesSummary = ({
  data: headlines,
}) => {
  const i18n = useContext(I18nContext);

  return (
    <PropertyRow
      propertyLabel={{ label: _TL_('Headlines') }}
    >
      <Text>
        {getHeadlinesCardSummaryDetails(i18n, headlines)}
      </Text>
    </PropertyRow>
  );
};

HeadlinesSummary.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};


export const LongHeadlinesSummary = ({
  data: longHeadlines,
}) => {
  const i18n = useContext(I18nContext);

  return (
    <PropertyRow
      propertyLabel={{ label: _TL_('Long Headlines') }}
    >
      <Text>
        {getLongHeadlinesCardSummaryDetails(i18n, longHeadlines)}
      </Text>
    </PropertyRow>
  );
};

LongHeadlinesSummary.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export const DescriptionsSummary = ({
  data: descriptions,
}) => {
  const i18n = useContext(I18nContext);

  return (
    <PropertyRow
      propertyLabel={{ label: _TL_('Descriptions') }}
    >
      <Text>
        {getDescriptionsCardSummaryDetails(i18n, descriptions)}
      </Text>
    </PropertyRow>
  );
};

DescriptionsSummary.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
